import VMasker from 'vanilla-masker';
import { ceilToDecimalPlaces } from './ceil-to-decimal-places.js';
export const toMoney = (value, options) => {
    var _a;
    const precision = (_a = options === null || options === void 0 ? void 0 : options.precision) !== null && _a !== void 0 ? _a : 2;
    const updatedPrecision = ceilToDecimalPlaces(value, precision);
    return VMasker.toMoney(updatedPrecision.toFixed(precision), options).replace(' ', '');
};
//# sourceMappingURL=to-money.js.map